import React from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Button,
  BoxProps,
  OutlinedInput
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import CustomTree, {
  TreeItemI
} from '../../../../../components/customTree/CustomTree'
import { useRatesDataGridContext } from '../contexts/ratesDataGrid/RatesDataGridContext'

const FilterBar: ReactFC<BoxProps> = ({ sx }) => {
  const {
    apiData,
    filterVisibilityId,
    changeFilterVisibility,
    filterRateId,
    changeFilterRateId,
    resetFilters,
    treeItems,
    changeTreeItems,
    loading
  } = useRatesDataGridContext()

  const { t } = useTranslation()

  const handleChangeVisibility = async (event: SelectChangeEvent) => {
    const value = event.target.value
    changeFilterVisibility(value)
  }

  const handleChangeRatesFilter = async (event: SelectChangeEvent) => {
    const value = event.target.value
    changeFilterRateId(value)
  }

  const handleChangeStablishments = async (newTreeItems: TreeItemI[]) => {
    changeTreeItems(newTreeItems)
  }

  const handleClearFilters = () => {
    resetFilters()
  }

  const initialLoad = loading && !apiData

  if (initialLoad) return null

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '6px',
        '& > *': {
          flex: '0 1 30%'
        },
        '& > *:not(:first-of-type)': {
          marginLeft: '1rem'
        },
        ...sx
      }}
    >
      <FormControl>
        <InputLabel>
          {t('apps.rates.rateDataGrid.labels.visibility')}
        </InputLabel>
        <Select
          label={`${t('apps.rates.rateDataGrid.labels.visibility')}`}
          value={filterVisibilityId || apiData?.filterList[2].id}
          onChange={handleChangeVisibility}
        >
          {apiData?.filterList.map((filter) => (
            <MenuItem value={filter.id} key={filter.id}>
              {filter.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box
        sx={{
          '& .tree__chips_container ': {
            maxHeight: '2rem',
            overflow: 'auto'
          }
        }}
      >
        <CustomTree
          selectProps={{
            fullWidth: true
          }}
          treeItems={treeItems}
          onChange={handleChangeStablishments}
        />
      </Box>
      <FormControl>
        <InputLabel shrink>
          {t('apps.rates.rateDataGrid.labels.rates')}
        </InputLabel>
        <Select
          value={filterRateId ?? ''}
          label={`${t('apps.rates.rateDataGrid.labels.rates')}`}
          onChange={handleChangeRatesFilter}
          displayEmpty
          input={
            <OutlinedInput
              notched
              label={`${t('apps.rates.rateDataGrid.labels.rates')}`}
            />
          }
        >
          <MenuItem value=''>Todas</MenuItem>
          {/* EXPECTING TO BE CHANGED TRADUCIR */}
          {apiData?.rateAuxList?.map((rate) => (
            <MenuItem value={rate.id} key={rate.id}>
              {rate.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box
        sx={{
          width: '20%'
        }}
      >
        <Button onClick={handleClearFilters}>
          {t('apps.rates.rateDataGrid.labels.clearFilters')}
        </Button>
      </Box>
    </Box>
  )
}
export default FilterBar
